module.exports = __webpack_public_path__ + "static/media/reward_point.549d1b0b.svg";